import {Link} from "gatsby"
import PropTypes from "prop-types"
import React from "react"
import Select from 'react-select';

const cities = [
  {
    label: "California",
    options: [
      {
        value: "Los Angeles",
        label: "Los Angeles"
      }, {
        value: "San Francisco",
        label: "San Francisco"
      }, {
        value: "San Diego",
        label: "San Diego"
      }, {
        value: "San Jose",
        label: "San Jose"
      }, {
        value: "San Mateo",
        label: "San Mateo"
      }
    ]
  }, {
    label: "Connecticut",
    options: [
      {
        value: "Hartford",
        label: "Hartford"
      }, {
        value: "Stamford",
        label: "Stamford"
      }
    ]
  }, {
    label: "Florida",
    options: [
      {
        value: "Fort Lauderdale Areas",
        label: "Fort Lauderdale Areas"
      }, {
        value: "Miami",
        label: "Miami"
      }, {
        value: "Orlando",
        label: "Orlando"
      }
    ]
  }, {
    label: "Georgia",
    options: [
      {
        value: "Atlanta",
        label: "Atlanta"
      }
    ]
  }, {
    label: "Illinois",
    options: [
      {
        value: "Chicago",
        label: "Chicago"
      }
    ]
  }, {
    label: "Maryland",
    options: [
      {
        value: "Rockville Areas",
        label: "Rockville Areas"
      }
    ]
  }, {
    label: "Massachusetts",
    options: [
      {
        value: "Boston",
        label: "Boston"
      }, {
        value: "Metro West",
        label: "Metro West"
      },{
        value: "Woburn",
        label: "Woburn"
      }, {
        value: "Worcester",
        label: "Worcester"
      }
    ]
  }, {
    label: "Minnesota",
    options: [
      {
        value: "Minneapolis",
        label: "Minneapolis"
      }
    ]
  }, {
    label: "New Jersey",
    options: [
      {
        value: "Central NJ",
        label: "Central NJ"
      },
      {
        value: "Jersey City/Hoboken",
        label: "Jersey City/Hoboken"
      },
      {
        value: "Northern NJ",
        label: "Northern NJ"
      }
    ]
  }, {
    label: "New York",
    options: [
      {
        value: "New York City",
        label: "New York City"
      }, {
        value: "Long Island",
        label: "Long Island"
      }
    ]
  }, {
    label: "North Carolina",
    options: [
      {
        value: "Charlotte",
        label: "Charlotte"
      }, {
        value: "Raleigh",
        label: "Raleigh"
      }
    ]
  }, {
    label: "Oregon",
    options: [
      {
        value: "Portland",
        label: "Portland"
      }
    ]
  }, {
    label: "Pennsylvania",
    options: [
      {
        value: "Philadelphia",
        label: "Philadelphia"
      }
    ]
  }, {
    label: "Rhode Island",
    options: [
      {
        value: "Providence",
        label: "Providence"
      }
    ]
  }, {
    label: "South Carolina",
    options: [
      {
        value: "Greenville",
        label: "Greenville"
      }
    ]
  }, {
    label: "Tennessee",
    options: [
      {
        value: "Memphis",
        label: "Memphis"
      }, {
        value: "Nashville",
        label: "Nashville"
      }
    ]
  }, {
    label: "Texas",
    options: [
      {
        value: "Austin",
        label: "Austin"
      }, {
        value: "Houston",
        label: "Houston"
      }, {
        value: "Dallas",
        label: "Dallas"
      }
    ]
  }, {
    label: "Virgina",
    options: [
      {
        value: "Reston",
        label: "Reston"
      }, {
        value: "Richmond Areas",
        label: "Richmond Areas"
      }
    ]
  }, {
    label: "Washington",
    options: [
      {
        value: "Seattle",
        label: "Seattle"
      }
    ]
  }, {
    label: "Washington DC",
    options: [
      {
        value: "Washington DC",
        label: "Washington DC"
      }
    ]
  }, {
    label: "Other Cities",
    options: [
      {
        value: "London, UK",
        label: "London, UK"
      }, {
        value: "Berlin, Germany",
        label: "Berlin, Germany"
      }, {
        value: "Frankfurt, Germany",
        label: "Frankfurt, Germany"
      }, {
        value: "Amsterdam, Holland",
        label: "Amsterdam, Holland"
      }, {
        value: "Abu Dhabi, Dubai",
        label: "Abu Dhabi, Dubai"
      }, {
        value: "Singapore",
        label: "Singapore"
      }, {
        value: "Hong Kong",
        label: "Hong Kong"
      }, {
        value: "China (Various Cities)",
        label: "China (Various Cities)"
      }, {
        value: "Sydney, Australia",
        label: "Sydney, Australia"
      }
    ]
  }
];

const LocationSelect = (props) => (<Select isMulti name="cities[]" options={cities} className="basic-multi-select" classNamePrefix="select"/>)

export default LocationSelect
